module.exports = __webpack_public_path__ + "img/2.056e92bc.png";